/**
 * 服务表单管理 Hook
 * 负责管理服务表单的引用和操作
 */
import React, { useRef, useCallback } from "react";

export interface UseServiceFormReturn {
  // 表单引用
  serviceFormRef: React.RefObject<any>;

  // 方法
  setServiceFormRef: (form: any) => void;
  resetServiceForm: () => void;
  setServiceFormValues: (values: any) => void;
  submitServiceForm: () => void;
  validateServiceForm: () => Promise<void>;
}

/**
 * 服务表单管理 Hook
 */
export const useServiceForm = (): UseServiceFormReturn => {
  // 服务表单引用
  const serviceFormRef = useRef<any>(null);

  /**
   * 设置服务表单引用
   * @param form 表单实例
   */
  const setServiceFormRef = useCallback((form: any) => {
    serviceFormRef.current = form;
  }, []);

  /**
   * 重置服务表单
   */
  const resetServiceForm = useCallback(() => {
    if (serviceFormRef.current) {
      serviceFormRef.current.resetFields();
    }
  }, []);

  /**
   * 设置服务表单值
   * @param values 表单值
   */
  const setServiceFormValues = useCallback((values: any) => {
    if (serviceFormRef.current && typeof serviceFormRef.current.setFieldsValue === "function") {
      serviceFormRef.current.setFieldsValue(values);
    }
  }, []);

  /**
   * 提交服务表单
   */
  const submitServiceForm = useCallback(() => {
    if (serviceFormRef.current && typeof serviceFormRef.current.submit === "function") {
      serviceFormRef.current.submit();
    }
  }, []);

  /**
   * 验证服务表单
   */
  const validateServiceForm = useCallback(async () => {
    if (serviceFormRef.current && typeof serviceFormRef.current.validateFields === "function") {
      await serviceFormRef.current.validateFields();
    }
  }, []);

  return {
    serviceFormRef,
    setServiceFormRef,
    resetServiceForm,
    setServiceFormValues,
    submitServiceForm,
    validateServiceForm,
  };
};

